import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";

const RoleGuard = ({ children, roles }) => {
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress color="info" />
            </MDBox>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user?.role)) {
        return (
            <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column">
                <MDTypography variant="h3" color="error" gutterBottom>
                    Access Denied
                </MDTypography>
                <MDTypography variant="body1">
                    You do not have permission to view this page.
                </MDTypography>
            </MDBox>
        );
    }

    return children;
};

export default RoleGuard;
